import { useFetch } from '@/utils/apiUtils';
import axios from 'axios';
import { getCheckWebView } from '@/utils/commonUtils';
import alertMsg from '@/utils/toastUtils';

/**
 * 2024.07.24 - Saylee
 * 웹뷰와의 브릿지 함수들 모음 api
 */
const bridgeApi = {
	/**
	 * 2024.07.023 - Saylee
	 * 파일다운로드 브릿지
	 * @param {*} param
	 * @returns
	 */
	getBase64FromBlobData: async (param) => {
		let checkWebView = getCheckWebView();
		try {
			// 안드로이드 웹뷰일경우 안드로이드 브릿지 호출
			if ('androidWebView' === checkWebView) {
				Android[param.type](param.data, param.fileName);
				// IOS 웹뷰일경우 IOS 브릿지 호출
			} else if ('iosWebView' === checkWebView) {
				window.webkit.messageHandlers.IOS.postMessage(param);
			}
		} catch (e) {
			alertMsg('파일다운로드에 실패하였습니다.', e, 'error');
		}
	},
	/**
	 * 2024.10.31. leejingyeong
	 * 제품연결 브릿지
	 * @param {*} param
	 * @returns
	 */
	openProductRegistration: async (param) => {
		let checkWebView = getCheckWebView();
		try {
			// 안드로이드 웹뷰일경우 안드로이드 브릿지 호출
			if ('androidWebView' === checkWebView) {
				Android[param.type](param.data);
				// IOS 웹뷰일경우 IOS 브릿지 호출
			} else if ('iosWebView' === checkWebView) {
				window.webkit.messageHandlers.IOS.postMessage(param);
			}
		} catch (e) {
			alertMsg('제품연결 호출에 실패하였습니다.', e, 'error');
		}
	},

	/**
	 * 2024.01.10. leejingyeong
	 * 로그인 정보 전달
	 * @param {*} param
	 */
	sendLoginInfo: async (param) => {
		let checkWebView = getCheckWebView();
		try {
			// 안드로이드 웹뷰일경우 안드로이드 브릿지 호출
			if ('androidWebView' === checkWebView) {
				Android[param.type](param.data);
				// IOS 웹뷰일경우 IOS 브릿지 호출
			} else if ('iosWebView' === checkWebView) {
				window.webkit.messageHandlers.IOS.postMessage(param);
			}
		} catch (e) {
			// alertMsg("로그인 정보 전달에 실패했습니다.", e , "error");
		}
	},

	getCurrentAppVersion: async (param) => {
		let checkWebView = getCheckWebView();
		try {
			// 안드로이드 웹뷰일경우 안드로이드 브릿지 호출
			if ('androidWebView' === checkWebView) {
				Android[param.type]();
				// IOS 웹뷰일경우 IOS 브릿지 호출
			} else if ('iosWebView' === checkWebView) {
				window.webkit.messageHandlers.IOS.postMessage(param);
			}
		} catch (e) {
			alertMsg('버전을 받아오는데에 실패했습니다.', e, 'error');
		}
	},
};

export default bridgeApi;
